import Vue from 'vue';
import Vuex from 'vuex';
// import router from '@/router';
import axios from '@core_utils/api/_axios.js';
import * as Sentry from '@sentry/browser';
import * as th from 'tree-helper';
import * as ih from '@core_utils/util';
import {mapSavedTranslations} from '@core_utils/api/questionTranslation.js';
import cloneDeep from 'lodash/cloneDeep';


import action_plan from '@core/store/action_plan';
import attachments from '@core/store/attachments';
import auditors from '@core/store/auditors';
import campaign_users from '@core/store/campaign_users';
import notices from '@core/store/notices';
import policies from '@core/store/policies';
import postassess from '@core/store/postassess';
import project_code from '@core/store/project_code';
import questions from '@core/store/provider_questions';
import reviews from '@core/store/reviews';
import score from '@core/store/score';
import user_campaigns_list from '@core/store/user_campaigns_list';

import industry_campaigns from './industry_campaigns';
import industry_scores from './industry_scores';
import dashboard from './dashboard';
import payment from './payment';
import admin from './admin';
import evaluations from './evaluations';
import ai_assessment from './ai_assessment';
import register from './register';
import contractor from './store-contractor/contractorStore';
import {generateSubcomponentDataBy} from '@core_utils/subComponent/subComponent';
import getAccesstokenNameByRoute from '@core_utils/api/getAccesstokenNameByRoute';
import commonLogout from '@core_utils/common-logout';
import dayjs from 'dayjs';

Vue.use(Vuex);

// readQuestionComposition 의 마지막 요청 번호 (늦게 온 이전 문항 응답이 최신 문항을 덮지 않게)
let latest_question_composition = 0;

const store = new Vuex.Store({
    modules: {
        questions: questions,
        score: score,
        auditors: auditors,
        notices: notices,
        user_campaigns_list: user_campaigns_list, // qesg assessment에서는 안쓸 것 같음 -> 1/18 이후 없애기
        policies: policies,
        reviews: reviews,
        campaign_users: campaign_users,
        industry_campaigns: industry_campaigns,
        industry_scores: industry_scores,
        postassess: postassess,
        project_code: project_code,
        dashboard: dashboard,
        action_plan: action_plan,
        payment: payment,
        attachments: attachments,
        contractor,
        admin,
        evaluations,
        ai_assessment,
        register
    },
    state: {
        //로그인
        accessToken: localStorage.getItem('accessToken') || '',
        user_name: localStorage.getItem('user_name') || '',
        company_name: localStorage.getItem('company_name') || '',
        company_id: localStorage.getItem('company_id') || '',
        user_id: localStorage.getItem('user_id') || '',
        e_mail: localStorage.getItem('e_mail') || '',
        isAuthenticated: '',
        is_admin: Number(localStorage.getItem('isAdmin')) || 0,
        
        //public or login_required
        mode: '',
        response_code: localStorage.getItem('response_code') || null,
        
        //서버정보
        frontend_host: 'http://localhost:8080',
        // 경로 접두사로만 쓴다(`backend_host + '/x'`). 받는 axios 가 baseURL(VUE_APP_BACKENDHOST)을 붙이므로 비워 둔다 —
        // 주소를 넣으면 같은 출처 빌드(/api)에서 /api/api/x 가 된다.
        backend_host: '',
        
        view_mode: 'provider',
        admin_mode: null, // 캠페인 리스트 = 'camp', 프로젝트 리스트 = 'project'
        campaigns: [],
        campaign_num: 0,
        map_campaigns: {},
        seperated_campaigns: [
            {state: 'ongoing', campaigns: []},
            {state: 'completed', campaigns: []}
        ],
        // seperated_campaigns 구조 => [{ state: 'ongoing', campaigns: [] }, { state: 'completed', campaigns: [] }]
        
        campaign_in_progress: {
            campaign_name: '',
            campaign_owner_id: '',
            campaign_id: '',
            template_code: '',
            campaign_description: '',
            campaign_description_e: '',
            steps: [],
            start_date: '',
            end_date: '',
            campaign_state: '',
            target_company_id: '',
            target_company_name: '',
            process_options: [], //'온라인실사', '현장실사', '후속모니터링'
            operator_name: '',
            is_public: false,
            target_companies_list: [],
            previous_campaign_id: null,
            auditors: []
        },
        
        template_in_progress: {
            template_name: '',
            template_code: '',
            template_contents: []
        },
        
        template_in_progress_loaded: false,
        
        question_in_progress: {
            question_code: '',
            question_name: '',
            question_infobox: '',
            question_contents: [],
            
            is_completed: 'false',
            visible: 'true',
            writable: 'true',
            comment: ''
        },
        
        question_in_progress_loaded: false,
        
        temp_save_status: false,
        
        login_alert: false,
        
        service_policy_mode: '이용약관',
        
        /////////////////////// User /////////////////////////////////////
        //user_aside
        now_page: '',
        
        //Managing_User
        selected_company: {},
        
        //Managing_Portfolio
        portfolio: {
            portfolio_id: '',
            portfolio_name: '',
            portfolio_description: '',
            portfolio_target_companies: []
        },
        
        //Managing_Companies
        campaign: {
            type: '', //owner or auditor
            campaign_id: '',
            campaign_name: '',
            campaign_name_e: '',
            campaign_name_c: '',
            campaign_description: '',
            camapign_description_e: '',
            camapign_description_c: '',
            policy_content: null,
            policy_content_e: null,
            policy_content_c: null,
            process_options: [],
            campaign_state: '',
            steps: [
                {
                    step_name: '',
                    start_date: '',
                    end_date: ''
                }
            ],
            start_date: '',
            end_date: '',
            campaign_target_companies: [],
            template_code: '',
            operator_name: '',
            is_public: false,
            previous_campaign_id: null,
            auditors: []
        },
        
        //editing_template
        template_tree: {
            user_id: '',
            template_name: null,
            template_code: null,
            template_type: null,
            template_scoring: 'manual',
            template_contents: []
        },
        previous_template_tree: {
            user_id: '',
            template_name: '',
            template_code: '',
            template_scoring: '',
            template_contents: []
        },
        question_composition: {
            question_name: '',
            question_name_e: '',
            question_name_c: '',
            question_code: '',
            question_infobox: '',
            question_infobox_e: '',
            question_infobox_c: '',
            question_contents: [],
        },
        
        question_subs: [],
        is_question_subs_loaded: false,
        searched_subs: [],
        editing_question_name: false,
        show_sub_finder: false,
        is_template_edit_state: false
    },
    getters: {
        getNumberOfQuestions(state) {
            var number_of_questions = 0;
            th.breadthFirstSearch(state.template_in_progress.template_contents, node => {
                if (node.children.length == 0) {
                    number_of_questions += 1;
                }
            });
            
            return number_of_questions;
        },
        getNumberOfCompletedQuestions(state) {
            var number_of_completed_questions = 0;
            th.breadthFirstSearch(state.template_in_progress.template_contents, node => {
                if (node.is_completed) {
                    if (node.is_completed == 'true') {
                        number_of_completed_questions += 1;
                    }
                }
            });
            return number_of_completed_questions;
        },
        getNumberOfCategoryQuestions(state) {
            //카테고리별로 하위 카테고리에 있는 계산 가능한 질문들의 총 수를 계산하여 Object로 리턴
            // { '0. 기업정보': 1, '1. 경제': 3, '2. 환경: 2', ... }
            // root_node: state.template_in_progress.template_contents
            let categories = state.template_in_progress.template_contents;
            let return_object = {};
            categories.forEach(item => {
                item.number_of_questions = 0;
                th.breadthFirstSearch(item, node => {
                    if (node.children.length == 0) {
                        item.number_of_questions += 1;
                    }
                });
                return_object[item.question_name] = item.number_of_questions;
            });
            return return_object;
        },
        getNumberOfCompletedCategoryQuestions(state) {
            //카테고리별로 하위 카테고리에 있는 완료된 질문들의 총 수를 계산하여 Object로 리턴
            // { '0. 기업정보': 1, '1. 경제': 0, '2. 환경: 1' ...}
            let categories = state.template_in_progress.template_contents;
            let return_object = {};
            categories.forEach(item => {
                item.number_of_completed_questions = 0;
                th.breadthFirstSearch(item, node => {
                    if (node.is_completed && node.is_completed == 'true') {
                        item.number_of_completed_questions += 1;
                    }
                });
                return_object[item.question_name] = item.number_of_completed_questions;
            });
            return return_object;
        },
        getProgressRate(state, getters) {
            let number_of_questions = getters.getNumberOfQuestions;
            let number_of_completed_questions = getters.getNumberOfCompletedQuestions;
            
            if (number_of_questions != 0) {
                return Math.round(number_of_completed_questions / number_of_questions * 100);
            } else return 0;
        },
        getCategoryProgressRate(state, getters) {
            // 카테고리별로 완료율을 계산하여 [ ] array로 반환
            // [ { category: '0. 기업정보', progress_rate: 10 }, { category: '1.경제', prgoress_rate: 15}, ... ]
            let number_of_category_questions = getters.getNumberOfCategoryQuestions;
            let number_of_completed_category_questions = getters.getNumberOfCompletedCategoryQuestions;
            
            let return_array = [];
            
            let keys = Object.keys(number_of_category_questions);
            
            keys.forEach(item => {
                let category_name = item;
                let denominator = number_of_category_questions[item];
                let value = number_of_completed_category_questions[item];
                return_array.push({
                    category: category_name,
                    progress_rate: Math.round(value / denominator * 100)
                });
            });
            return return_array;
        },
        getTemplateTree(state) {
            return state.template_tree;
        },
        getTemplateContents(state) {
            // console.log('template_contents')
            // console.log(state.template_tree.template_contents)
            if (state.template_tree.template_contents == '' || state.template_tree.template_contents.length == 0) return [];
            else if (state.template_tree.template_contents[0]._vm == undefined) return state.template_tree.template_contents;
            else return state.template_tree.template_contents[0]._vm.store.getPureData();
        },
        getQuestionComposition(state) {
            return state.question_composition;
        },
        getSearchedSubs(state) {
            return state.searched_subs;
        },
        isEmptySearchedSubs(state) {
            if (state.searched_subs.length == 0) return true;
            else return false;
        },
        getQuestions: function (state) {
            return state.questions;
        },
        getQuestionSubs: function (state) {
            return state.question_subs;
        },
        getQuestionSubBySubcode: function (state, sub_code) {
            const idx = state.question_subs.findIndex(item => {
                return item.sub_code === sub_code;
            });
            return state.question_subs[idx];
        },
        getShowTemplateSubFinder(state) {
            return state.show_sub_finder;
        },
        getTemplateEditStatus(state) {
            return state.is_template_edit_state;
        },
        isAuthenticated: function (state) {
            return state.isAuthenticated;
        },
        isAdmin: function (state) {
            return Number(state.is_admin);
        },
        getAdminLevel: function (state) {
            //유저의 권한 레벨을 정의
            // 0: CAMPAIGN_USER 캠페인에 참여하는 유저(현업부서)
            // 1: CAMPAIGN_ADMIN 기업 COMPANY_USER를 추가하고, Question별 읽기/편집 권한 부여 가능
            // 2: CAMPAIGN_AUDITOR 캠페인 실사/평가에 참여. 접근이 허용된 캠페인의 정보를 확인하고, 점수를 매길 수 있음
            // 3: CAMPAIGN_MANAGER. 캠페인/포트폴리오/템플릿 생성/Auditor 계정생성, 캠페인/포트폴리오/템플릿 매핑 가능.
            //    CAMPAIGN_MANAGER는 자신이 생성한 CAMPAIGN에 한해서 모든 권한 사용 가능
            // 4: SUPER_ADMINISTRATOR. 데이터플레어 캠페인/포트폴리오/유저 생성/삭제/매핑 차원에서 모든 권한을 가짐
            if (state.is_admin == 0) return 'CAMPAIGN_USER'; // 참여자
            else if (state.is_admin == 1) return 'CAMPAIGN_ADMIN'; // 캠페인 리더
            else if (state.is_admin == 2) return 'CAMPAIGN_AUDITOR'; // 실사 전문가
            else if (state.is_admin == 3) return 'CAMPAIGN_MANAGER'; // 캠페인 매니저
            else if (state.is_admin == 4) return 'SUPER_ADMINISTRATOR'; // 시스템 관리자
            else if (state.is_admin == 5) return 'MASTER';
            else return 'NOT_DEFINED';
        },
        getUserName: function (state) {
            return state.user_name;
        },
        getCompanyName: function (state) {
            return state.company_name;
        },
        getEMail: function (state) {
            return state.e_mail;
        },
        getAccessToken: function (state) {
            return state.accessToken;
        },
        getQuestionInfoBox: function (state) {
            return state.question_composition.question_infobox;
        },
        getTargetCompanyID: (state) => {
            let target_company_id = 0;
            if (state.view_mode == 'provider') {
                target_company_id = state.company_id;
            } else {
                target_company_id = state.questions.answer_company.company_id;
                
            }
            return target_company_id;
        },
        getCampaign(state) {
            return state.campaign;
        },
        getTargetCampaignID: (state) => (previous) => {
            let target_campaign_id = 0;
            if (state.view_mode == 'provider') {
                if (previous == true) {
                    target_campaign_id = state.campaign_in_progress.previous_campaign_id;
                } else {
                    target_campaign_id = state.campaign_in_progress.campaign_id;
                }
            } else {
                if (previous == true) {
                    target_campaign_id = state.campaign.previous_campaign_id;
                } else {
                    target_campaign_id = state.campaign.campaign_id;
                }
            }
            return target_campaign_id;
        },
        isLoggedIn: state => !!state.accessToken,
        
    },
    mutations: {
        ///////////////////////////////////Provider////////////////////////////////////////
        set_map_map_campaigns(state, campaigns) {
            state.map_campaigns = campaigns;
        },
        change_login_company(state, {company_name, company_id}) { //슈퍼관리자용
            // if(state.is_admin < 4){
            //   return false
            // }
            // else{
            //   state.company_name = company_name
            //   state.company_id = company_id
            // }
            state.company_name = company_name;
            state.company_id = company_id;
        },
        set_view_mode(state, view_mode) {
            state.view_mode = view_mode;
        },
        set_admin_mode(state, admin_mode) {
            state.admin_mode = admin_mode;
        },
        reset_store(state) {
            state.campaigns = [];
            state.campaign_num = 0;
            state.seperated_campaigns = [
                {state: 'ongoing', campaigns: []},
                {state: 'completed', campaigns: []}
            ];
            
            state.campaign_in_progress = {
                campaign_name: '',
                campaign_name_e: '',
                campaign_name_c: '',
                camapign_description: '',
                camapign_description_e: '',
                camapign_description_c: '',
                campaign_owner_id: '',
                campaign_id: '',
                template_code: '',
                process_options: [],
                campaign_description: '',
                steps: [],
                start_date: '',
                end_date: '',
                campaign_state: '',
                target_company_id: '',
                target_company_name: '',
                operator_name: '',
                is_public: false,
                target_companies_list: [],
                previous_campaign_id: null,
                auditors: []
            };
            
            state.template_in_progress = {
                template_name: '',
                template_code: '',
                template_contents: []
            };
            
            state.template_in_progress_loaded = false;
            
            state.question_in_progress = {
                question_code: '',
                question_name: '',
                question_name_e: '',
                question_name_c: '',
                question_infobox: '',
                question_infobox_e: '',
                question_infobox_c: '',
                question_contents: [],
                
                is_completed: 'false',
                visible: 'true',
                writable: 'true',
                comment: ''
            },
                
            state.question_in_progress_loaded = false;
            state.temp_save_status = false;
            state.login_alert = false;
            // 로그아웃 뒤 뒤로가기로 약관 화면에 돌아와도 빈 화면이 되지 않게 기본값으로 둔다
            state.service_policy_mode = '이용약관';
            
            state.now_page = '';
            state.selected_company = {};
            state.portfolio = {
                portfolio_id: '',
                portfolio_name: '',
                portfolio_description: '',
                portfolio_target_companies: []
            };
            
            state.campaign = {
                type: '', //owner or auditor
                campaign_id: '',
                campaign_name: '',
                campaign_name_e: '',
                campaign_name_c: '',
                campaign_description: '',
                camapign_description_e: '',
                camapign_description_c: '',
                policy_content: null,
                policy_content_e: null,
                policy_content_c: null,
                process_options: [],
                campaign_state: '',
                steps: [
                    {
                        step_name: '',
                        start_date: '',
                        end_date: ''
                    }
                ],
                start_date: '',
                end_date: '',
                campaign_target_companies: [],
                template_code: '',
                operator_name: '',
                is_public: false,
                previous_campaign_id: null,
                auditors: []
            };
            
            // editing_template
            state.template_tree = {
                user_id: '',
                template_name: '',
                template_code: '',
                template_scoring: '',
                template_contents: []
            };
            
            state.previous_template_tree = {
                user_id: '',
                template_name: '',
                template_code: '',
                template_scoring: '',
                template_contents: []
            };
            
            state.question_composition = {
                question_name: '',
                question_name_e: '',
                question_name_c: '',
                question_code: '',
                question_infobox: '',
                question_infobox_e: '',
                question_infobox_c: '',
                question_contents: [],
            };
            
            state.question_subs = [];
            state.is_question_subs_loaded = false;
            state.searched_subs = [];
            state.editing_question_name = false;
            state.is_template_edit_state = false;
            state.show_sub_finder = false;
        },
        update_login_alert(state, flag) {
            state.login_alert = flag;
        },
        update_service_policy_mode(state, mode) {
            state.service_policy_mode = mode;
        },
        update_campaign_in_progress(state, new_campaign) {
            state.campaign_in_progress = new_campaign;
            state.template_in_progress.template_code = new_campaign.template_code;
        },
        update_campaigns(state, new_campaigns) {
            let temp_campaign_list = new_campaigns.sort((a, b) => {
                return b.start_date - a.start_date;
            });
            
            state.campaigns = temp_campaign_list;
        },
        update_campaign_num(state, new_campaign_num) {
            state.campaign_num = new_campaign_num;
        },
        update_seperated_campaigns(state, new_seperated_campaigns) {
            const pre_ongoing_state = state.seperated_campaigns.find(({state}) => state === 'ongoing');
            const pre_completed_state = state.seperated_campaigns.find(({state}) => state === 'completed');
            const new_ongoing_state = new_seperated_campaigns.find(({state}) => state === 'ongoing');
            const new_completed_state = new_seperated_campaigns.find(({state}) => state === 'completed');
            
            const isUpdatedOnGoingCampaign = pre_ongoing_state.campaigns.length > 0 && pre_ongoing_state.campaigns.length !== new_ongoing_state.campaigns.length;
            const isUpdatedOnCompletedCampaign = pre_completed_state.campaigns.length > 0 && pre_completed_state.campaigns.length !== new_completed_state.campaigns.length;
            
            
            if (isUpdatedOnGoingCampaign || isUpdatedOnCompletedCampaign) {
                state.seperated_campaigns = Object.assign({}, state.seperated_campaigns, new_seperated_campaigns);
            } else {
                state.seperated_campaigns = new_seperated_campaigns;
            }
            
        },
        update_template_in_progress(state, new_template) {
            state.template_in_progress = new_template;
        },
        make_template_tree(state, question_array) {
            th.breadthFirstSearch(state.template_in_progress.template_contents, node => {
                let idx = question_array.findIndex(item => {
                    return item.question_code == node.question_code;
                });
                if (idx > -1) {
                    node.question_name = question_array[idx].question_name;
                    node.question_name_e = question_array[idx].question_name_e;
                    node.question_name_c = question_array[idx].question_name_c;
                    node.question_infobox = question_array[idx].question_infobox;
                    node.question_infobox_e = question_array[idx].question_infobox_e;
                    node.question_infobox_c = question_array[idx].question_infobox_c;
                    node.question_contents = question_array[idx].question_contents;
                    node.visible = question_array[idx].visible;
                    node.writable = question_array[idx].writable;
                    node.number_of_comment = question_array[idx].number_of_comment;
                    node.number_of_new_comment = question_array[idx].number_of_new_comment;
                    node.is_completed = question_array[idx].is_completed;
                    node.comment = question_array[idx].comment;
                    
                    let x = node;
                    while ((x.visible == true || x.writable == true) && x.parent) {
                        x.parent.visible = x.visible;
                        x.parent.writable = x.writable;
                        x = x.parent;
                    }
                    
                }
            });
            
            if (state.is_admin >= 1) { //관리자 이상일 경우이며, 이 경우 visible, writable 무시
                th.breadthFirstSearch(state.template_in_progress.template_contents, node => {
                    node.visible = true,
                    node.writable = true;
                });
            }
            state.template_in_progress_loaded = true;
        },
        add_custom_template(state, custom_template) {
            for (let i = 0; i < custom_template.template_contents.length; i++) {
                state.template_in_progress.template_contents.push(custom_template.template_contents[i]);
            }
        },
        update_question_in_progress(state, new_question_in_progress) {
            state.question_in_progress = new_question_in_progress;
            
            let temp_obj = {...state.template_in_progress};
            th.breadthFirstSearch(temp_obj.template_contents, node => {
                if (node.question_code == new_question_in_progress.question_code) {
                    node.is_completed = new_question_in_progress.is_completed;
                    node.comment = new_question_in_progress.comment;
                }
            });
            state.template_in_progress = temp_obj;
            
        },
        update_template_in_progress_loaded(state, {loading_status}) {
            state.template_in_progress_loaded = loading_status;
        },
        update_question_in_progress_loaded(state, {loading_status}) {
            state.question_in_progress_loaded = loading_status;
        },
        
        update_temp_save_status(state, flag) {
            state.temp_save_status = flag;
        },
        ////////////////////////////////////Public_Engagement//////////////////////////////
        make_mode_public(state, response_code) {
            state.mode = 'public';
            if (response_code != null) {
                state.response_code = response_code;
                localStorage.setItem('response_code', state.response_code);
            }
            if (state.response_code == null) {
                state.response_code = 'R' + Math.floor((Math.random() * 999999)) + 1;
                localStorage.setItem('response_code', state.response_code);
            }
            
        },
        ////////////////////////////////////User///////////////////////////////////////////
        make_template_tree_for_user_view(state, question_array) {
            th.breadthFirstSearch(state.template_tree.template_contents, node => {
                let idx = question_array.findIndex(item => {
                    return item.question_code == node.question_code;
                });
                if (idx > -1) {
                    node.question_name = question_array[idx].question_name;
                    node.question_name_e = question_array[idx].question_name_e;
                    node.question_name_c = question_array[idx].question_name_c;
                    node.question_infobox = question_array[idx].question_infobox;
                    node.question_infobox_e = question_array[idx].question_infobox_e;
                    node.question_infobox_c = question_array[idx].question_infobox_c;
                    
                    if (typeof (question_array[idx].question_contents) == 'string') {
                        node.question_contents = JSON.parse(question_array[idx].question_contents);
                    } else {
                        node.question_contents = question_array[idx].question_contents;
                    }
                    
                    node.visible = question_array[idx].visible;
                    node.writable = question_array[idx].writable;
                    node.num_of_comment = question_array[idx].num_of_comment;
                    node.number_of_new_comment = question_array[idx].number_of_new_comment;
                    node.is_completed = question_array[idx].is_completed;
                    node.comment = question_array[idx].comment;
                }
            });
            
            th.breadthFirstSearch(state.template_in_progress.template_contents, node => {
                node.visible = true,
                node.writable = true;
            });
        },
        // add_custom_template_for_user_view(state, custom_template){
        //     for (let i=0; i<custom_template.template_contents.length; i++){
        //         state.template_tree.template_contents.push(custom_template.template_contents[i])
        //     }
        //     // console.log(state.template_tree.template_contents)
        // },
        update_now_page(state, new_page) {
            state.now_page = new_page;
        },
        update_template_tree(state, template_tree) {
            try {
                if (!template_tree) {
                    state.template_tree = {
                        template_id: 0,
                        user_id: state.user_id,
                        template_code: 't' + Math.floor(Math.random() * 1000000000),
                        template_type: null,
                        template_name: null,
                        template_contents: []
                    };
                } else {
                    const _template_tree = {...state.template_tree, ...template_tree};
                    if (typeof _template_tree.template_contents === 'string') {
                        _template_tree.template_contents = JSON.parse(template_tree.template_contents);
                    } else if (!_template_tree.template_contents) {
                        _template_tree.template_contents = [];
                    }
                    
                    const _template_contents = cloneDeep(_template_tree.template_contents);
                    if (_template_contents && Array.isArray(_template_contents) && _template_contents.length) {
                        _template_tree['template_contents'] = _template_contents.reduce((_contents, _con) => {
                            if (_con.children && _con.children.length) {
                                _con.children = _con.children.reduce((_children, _child) => {
                                    _child.isCheckedTitleValidation = false;
                                    _child.isNeededTitleValidation = false;
                                    _children.push(_child);
                                    return _children;
                                }, []);
                            }
                            _contents.push(_con);
                            return _contents;
                        }, []);
                    }
                    
                    state.template_tree = _template_tree;
                }
                
                state.question_subs = [];
                state.question_composition = {
                    question_name: '',
                    question_name_e: '',
                    question_name_c: '',
                    question_code: '',
                    question_infobox: '',
                    question_infobox_e: '',
                    question_infobox_c: '',
                    question_contents: [],
                };
            } catch (error) {
                return Promise.reject(error);
            }
        },
        // update_template_tree_name (state, updated_template_tree_name) {
        //     state.template_tree.template_name = updated_template_tree_name
        // },
        // update_template_tree_type (state, updated_template_tree_type) {
        //     state.template_tree.template_type = updated_template_tree_type
        // },
        update_previous_template_tree(state, template_tree) {
            state.previous_template_tree = template_tree;
        },
        update_question_code(state, question_code) {
            state.question_composition.question_code = question_code;
        },
        update_question_name(state, {'question_name': question_name}) {
            state.question_composition.question_name = question_name;
        },
        update_question_infobox(state, _updated_infobox) {
            state.question_composition.question_infobox = _updated_infobox;
        },
        update_question_composition(state, _updated_question_compositon) {
            if (!_updated_question_compositon) {
                state.question_composition = {
                    question_name: '',
                    question_name_e: '',
                    question_name_c: '',
                    question_code: '',
                    question_infobox: '',
                    question_infobox_e: '',
                    question_infobox_c: '',
                    question_contents: [],
                };
            } else {
                _updated_question_compositon.question_contents = typeof _updated_question_compositon.question_contents === 'string'
                    ? ih.JSONParse(_updated_question_compositon.question_contents)
                    : _updated_question_compositon.question_contents;
                
                // 저장 응답은 번역을 _ea/_em 키로 주므로 화면이 쓰는 _e/_c 로 옮긴다(키가 없으면 기존 값 유지)
                state.question_composition = {
                    ...state.question_composition,
                    ..._updated_question_compositon,
                    ...mapSavedTranslations(_updated_question_compositon),
                };
            }
            
        },
        align_question_contents(state) {
            state.question_composition.question_contents = state.question_subs.map(x => x.sub_code);
        },
        // read_question_composition_failure (state) {
        //     state.question_composition.question_contents = []
        //     state.question_subs = []
        // },
        reset_question_subs(state) {
            state.question_subs = [];
        },
        update_question_subs(state, new_subs) {
            state.question_subs = new_subs;
            state.question_composition.question_contents = state.question_subs.map(x => x.sub_code);
        },
        add_question_sub(state, new_sub) {
            state.question_subs.push(new_sub);
            state.question_composition.question_contents = state.question_subs.map(x => x.sub_code);
        },
        update_is_question_subs_loaded(state, _is_loaded) {
            state.is_question_subs_loaded = _is_loaded;
        },
        delete_question_sub(state, sub_code) {
            const idx = state.question_subs.findIndex(function (item) {
                return item.sub_code === sub_code;
            });
            if (idx > -1) {
                state.question_subs.splice(idx, 1);
                state.question_composition.question_contents = state.question_subs.map(x => x.sub_code);
            }
        },
        update_question_sub(state, new_sub) {
            const idx = state.question_subs.findIndex(item => item.sub_code === new_sub.sub_code);
            if (idx > -1) {
                Vue.set(state.question_subs, idx, generateSubcomponentDataBy({...state.question_subs[idx], ...new_sub}));
            } else {
                state.question_subs.push(generateSubcomponentDataBy({...new_sub}));
            }
            
            state.question_composition.question_contents = state.question_subs.map(x => x.sub_code);
        },
        reset_searched_subs(state) {
            state.searched_subs = [];
        },
        add_searched_sub(state, new_sub) {
            state.searched_subs.push(new_sub);
        },
        update_searched_subs(state, new_subs) {
            //for (var i=0; i<new_subs.length; i++)
            //{
            //    new_subs[i].sub_condition = ih.JSONParse(new_subs[i].sub_condition)
            //    new_subs[i].sub_data_header = ih.JSONParse(new_subs[i].sub_data_header)
            //    new_subs[i].sub_data_contents = ih.JSONParse(new_subs[i].sub_data_contents)
            //}
            state.searched_subs = new_subs;
        },
        delete_searched_sub(state, sub_code) {
            const idx = state.searched_subs.findIndex(item => item.sub_code == sub_code);
            if (idx > -1) {
                state.searched_subs.splice(idx, 1);
            }
        },
        update_Show_Template_SubFinder(state, _status) {
            if (!state.is_template_edit_state) {
                state.show_sub_finder = typeof _status === 'undefined' ? !state.show_sub_finder : _status;
            } else {
                state.show_sub_finder = false;
            }
        },
        update_Template_EditMode(state, _status) {
            state.is_template_edit_state = _status;
        },
        update_selected_company(state, new_company) {
            state.selected_company = !new_company
                ? {}
                : new_company;
        },
        add_portfolio_target_company(state, new_company) {
            if (new_company.company_id != '' && state.portfolio.portfolio_target_companies.length > -1) {
                let idx = state.portfolio.portfolio_target_companies.findIndex((item) => {
                    return item.company_id == new_company.company_id;
                });
                // console.log(idx)
                if (idx > -1) {
                    console.log('이미 목록에 존재하는 기업입니다.');
                } else state.portfolio.portfolio_target_companies.push(new_company);
            } else {
                state.portfolio.portfolio_target_companies.push(new_company);
                // window.alert('목록에 추가할 기업을 선택하여 주십시오')
                // console.log(new_company);
                // console.log(state.portfolio)
            }
            
        },
        delete_portfolio_target_company(state, deletable_company) {
            const idx = state.portfolio.portfolio_target_companies.findIndex(function (item) {
                return item.company_id == deletable_company.company_id;
            });
            if (idx > -1) state.portfolio.portfolio_target_companies.splice(idx, 1);
            else window.alert('삭제할 기업이 존재하지 않습니다.');
        },
        reset_portfolio_target_companies(state) {
            state.portfolio_target_companies = [];
        },
        update_portfolio(state, new_portfolio) {
            state.portfolio = new_portfolio;
        },
        update_campaign(state, new_campaign) {
            if (!new_campaign) {
                state.campaign = {
                    type: '', //owner or auditor
                    campaign_id: '',
                    campaign_name: '',
                    campaign_name_e: '',
                    campaign_name_c: '',
                    campaign_description: '',
                    camapign_description_e: '',
                    camapign_description_c: '',
                    policy_content: null,
                    policy_content_e: null,
                    policy_content_c: null,
                    process_options: [],
                    campaign_state: '',
                    steps: [
                        {
                            step_name: '',
                            start_date: '',
                            end_date: ''
                        }
                    ],
                    start_date: '',
                    end_date: '',
                    campaign_target_companies: [],
                    template_code: '',
                    operator_name: '',
                    is_public: false,
                    previous_campaign_id: null,
                    auditors: []
                };
            } else {
                state.campaign = {...state.campaign, ...new_campaign};
            }
        },
        update_campaign_actionplan(state, updated_campaign) {
            const _updating_campaign_idx = state.seperated_campaigns[updated_campaign.group].campaigns.findIndex(({request_id}) => request_id === updated_campaign.actionplan.request_id);
            const idx = state.seperated_campaigns[updated_campaign.group]?.campaigns?.[_updating_campaign_idx]?.actionplan?.findIndex(({id}) => {
                return id === updated_campaign.actionplan.id;
            });
            if (idx != null && idx > -1) {
                state.seperated_campaigns[updated_campaign.group].campaigns[_updating_campaign_idx].actionplan.splice(idx, 1, updated_campaign.actionplan);
            }
        },
        logout(state) {
            state.accessToken = null;
            state.isAuthenticated = '';
            state.user_name = '';
            state.company_name = '';
            state.e_mail = '';
            // 같은 창에서 다음 사람이 로그인할 때 이전 계정의 권한·식별자가 남지 않게 한다
            state.is_admin = 0;
            state.user_id = '';
            state.company_id = '';
            // delete localStorage.accessToken
            // delete localStorage.user_name
            // delete localStorage.company_name
            // delete localStorage.e_mail
            // delete localStorage.isAuthenticated
            // delete localStorage.isAdmin
            const _accesstoken_name = getAccesstokenNameByRoute();
            localStorage.removeItem(_accesstoken_name);
            localStorage.removeItem('accesstoken'); // 토큰 키 통일: 잔여 소문자 키도 제거(부팅 마이그레이션 resurrection 방지)
            localStorage.removeItem('user_name');
            localStorage.removeItem('user_id');
            localStorage.removeItem('company_name');
            localStorage.removeItem('company_id');
            localStorage.removeItem('e_mail');
            localStorage.removeItem('isAuthenticated');
            localStorage.removeItem('authenticated');
            localStorage.removeItem('isAdmin');
            localStorage.removeItem('type');
            localStorage.removeItem('is_admin');
            localStorage.removeItem('is_confirmed');
            localStorage.removeItem('subscription');
            localStorage.removeItem('tel');
            localStorage.removeItem('is_premium');
            // axios.defaults.headers.common['Authorization'] = '';
        },
        auth_request(state) {
            state.isAuthenticated = 'loading';
            localStorage.setItem('isAuthenticated', 'loading');
        },
        auth_success(state, {
            'accessToken': accessToken,
            'user_name': user_name,
            'company_name': company_name,
            'company_id': company_id,
            'e_mail': e_mail,
            'is_admin': is_admin,
            'user_id': user_id
        }) {
            state.isAuthenticated = 'success';
            localStorage.setItem('isAuthenticated', 'success');
            
            state.accessToken = accessToken;
            state.user_name = user_name;
            state.company_name = company_name;
            state.company_id = company_id;
            state.e_mail = e_mail;
            state.is_admin = is_admin;
            state.user_id = user_id;
            
            localStorage.setItem('accessToken', accessToken);
            localStorage.setItem('user_name', user_name);
            localStorage.setItem('company_name', company_name);
            localStorage.setItem('company_id', company_id);
            localStorage.setItem('e_mail', e_mail);
            localStorage.setItem('isAdmin', is_admin);
            localStorage.setItem('user_id', user_id);
            
            //   console.log(accessToken);
            axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
        },
        auth_error(state) {
            state.isAuthenticated = 'error';
            localStorage.setItem('isAuthenticated', 'error');
        },
        
    },
    actions: {
        async read_company_recieved_campaigns({commit}, {user_id}) {
            // eslint-disable-next-line no-useless-catch
            try {
                const _res_user_campaingn = await axios.get(`/campaigns/user/${user_id}`);
                let _user_campaingns = _res_user_campaingn.data;
                if (_user_campaingns && _user_campaingns.length) {
                    const _request_ids = _user_campaingns.map(({request_id}) => request_id);
                    // action-plans 가져오기
                    const _res_actionplans = await axios.get('/actionplans', {params: {request_id: _request_ids}});
                    if (_res_actionplans.data.length) {
                        _user_campaingns = _user_campaingns.map((_campaingn) => {
                            const _campaingn_actionplan = _res_actionplans.data.filter(({request_id}) => request_id === _campaingn.request_id);
                            return {..._campaingn, actionplan: _campaingn_actionplan || null};
                        });
                    }
                }
                
                // ongoing: 'in_progress', 'in_assessment', 'requested'
                // completed: 'completed', 'canceled'
                const map_campaigns = {};
                const campaignGroupByStatus = _user_campaingns.reduce((groupByStatus, campaign) => {
                    map_campaigns[campaign.campaign_id] = campaign;
                    
                    if(campaign.project_code === 'POSCO_25'){
                        campaign.campaign_description = campaign.campaign_description.replaceAll('2025년 9월 26일 23:59 (KST)', '2025년 10월 9일 23:59 (KST)');
                        campaign.campaign_description_e = campaign.campaign_description_e.replaceAll('September 26, 2025, 23:59 (KST)', 'October 9, 2025, 23:59 (KST)');
                    }
                    if(campaign.project_code === 'SEAH_BESTEEL_25' || campaign.project_code === 'SEAH_CSS_25'){
                        campaign.campaign_description = campaign.campaign_description.replaceAll('2025년 9월 26일 23:59 (KST)', '2025년 10월 31일 23:59 (KST)');
                        campaign.campaign_description_e = campaign.campaign_description_e.replaceAll('September 26, 2025, 23:59 (KST)', 'October 31, 2025, 23:59 (KST)');
                    }
                    
                    if (['in_progress', 'in_assessment', 'requested'].includes(campaign.status_code)) {
                        groupByStatus.ongoing.push(campaign);
                    } else {
                        groupByStatus.completed.push(campaign);
                    }
                    return groupByStatus;
                }, {ongoing: [], completed: []});
                
                commit('update_seperated_campaigns', [
                    {state: 'ongoing', campaigns: campaignGroupByStatus.ongoing},
                    {state: 'completed', campaigns: campaignGroupByStatus.completed}
                ]);
                commit('update_campaign_num', _res_user_campaingn.data.length);
                commit('set_map_map_campaigns', map_campaigns);
            } catch (error) {
                throw error;
            }
        },
        async read_recieved_campaigns({commit}, {user_id}) {
            // eslint-disable-next-line no-useless-catch
            try {
                const response = await axios.get(`/company/campaigns/${user_id}`);
                
                let temp_campaigns = response.data;
                temp_campaigns.forEach(campaign => {
                    campaign.steps.forEach(x => {
                        x.start_date = ih.stringToDate(x.start_date);
                    });
                    
                    campaign.steps.forEach(y => {
                        y.end_date = ih.stringToDate(y.end_date);
                        let zerodate = y.end_date;
                        zerodate.setHours(zerodate.getHours() + 23);
                        zerodate.setMinutes(zerodate.getMinutes() + 59);
                    });
                    
                    campaign.start_date = ih.stringToDate(campaign.start_date);
                    campaign.end_date = ih.stringToDate(campaign.end_date);
                    
                    let end_zero = campaign.end_date;
                    end_zero.setHours(end_zero.getHours() + 23);
                    end_zero.setMinutes(end_zero.getMinutes() + 59);
                });
                
                const campaignGroupByStatus = temp_campaigns.reduce((groupByStatus, campaign) => {
                    if (['in_progress', 'in_assessment', 'requested'].includes(campaign.status_code)) {
                        groupByStatus.ongoing.push(campaign);
                    } else {
                        groupByStatus.completed.push(campaign);
                    }
                    return groupByStatus;
                }, {ongoing: [], completed: []});
                
                commit('update_seperated_campaigns', [
                    {state: 'ongoing', campaigns: campaignGroupByStatus.ongoing},
                    {state: 'completed', campaigns: campaignGroupByStatus.completed}
                ]);
                commit('update_campaign_num', temp_campaigns.length);
            } catch (error) {
                if (error.response) {
                    if (error.response.status === 401) {
                        await commonLogout();
                    }
                }
            }
        },
        async readTemplateInProgress({state, commit, dispatch}, {template_code, company_id}) {
            try {
                commit('update_template_in_progress_loaded', {loading_status: false});
                
                const new_template_tree = {
                    template_name: '',
                    template_code: '',
                    template_scoring: '',
                    template_type: '',
                    template_contents: []
                };
                
                const response = await axios.get('/read_template', {
                    params: {template_code, company_id}
                });
                const result = response.data;
                new_template_tree.template_name = result.template_name;
                new_template_tree.template_code = result.template_code;
                new_template_tree.template_scoring = result.template_scoring;
                new_template_tree.template_type = result.template_type;
                new_template_tree.template_contents = ih.JSONParse(result['template_contents']);
                
                commit('update_template_in_progress', new_template_tree);
                
                // 트리(완료 여부 등)까지 반영된 뒤 끝낸다 — 평가를 연달아 바꿀 때 앞 평가의 늦은 응답이 뒤 평가 트리를 덮지 않게
                if (state.mode !== 'public') {
                    await dispatch('makeTemplateTree');
                } else {
                    await dispatch('makePublicTemplateTree');
                }
                
            } catch (error) {
                console.log(error);
                
                if (error.response) {
                    if (error.response.status === 401) {
                        await commonLogout();
                    }
                }
            }
        },
        async makeTemplateTree({commit, state}) {
            try {
                const response = await axios.get('/make_template_tree', {
                    params: {
                        campaign_id: state.campaign_in_progress.campaign_id,
                        e_mail: state.e_mail,
                        company_id: state.company_id,
                        mode: 'qesg_assessment'
                    }
                });
                commit('make_template_tree', response.data);
            } catch (error) {
                console.log(error);
            }
        },
        async makeTemplateTreeByCompanyId({commit, state}, {campaign_id, company_id}) {
            try {
                const camp_id = campaign_id ? campaign_id : state.campaign.campaign_id;
                const response = await axios.get('/make_template_tree_by_company_id', {
                    params: {campaign_id: camp_id, company_id}
                });
                commit('make_template_tree_for_user_view', response.data);
            } catch (error) {
                console.log(error);
            }
        },
        readQuestionInProgress({commit, state}, question_code) {
            const path = state.backend_host + '/read_question_answer';
            
            let new_question_in_progress = {
                question_code: question_code,
                is_completed: '',
                comment: '',
                
                question_name: '',
                question_name_e: '',
                question_name_c: '',
                question_infobox: '',
                question_infobox_e: '',
                question_infobox_c: '',
                question_contents: []
            };
            
            commit('update_question_in_progress_loaded', {loading_status: false});
            
            return axios.get(path, {
                params: {
                    question_code: question_code,
                    company_id: state.company_id,
                    campaign_id: state.campaign_in_progress.campaign_id
                }
            })
                .then(response => {
                    new_question_in_progress.is_completed = response.data.is_completed;
                    new_question_in_progress.comment = response.data.comment;
                    new_question_in_progress.question_name = response.data.question_name;
                    new_question_in_progress.question_name_e = response.data.question_name_e;
                    new_question_in_progress.question_name_c = response.data.question_name_c;
                    new_question_in_progress.question_infobox = response.data.question_infobox;
                    new_question_in_progress.question_infobox_e = response.data.queston_infobox_e;
                    new_question_in_progress.question_infobox_c = response.data.queston_infobox_c;
                    new_question_in_progress.question_contents = JSON.parse(response.data.question_contents);
                    commit('update_question_in_progress', new_question_in_progress);
                    commit('update_question_in_progress_loaded', {loading_status: true});
                })
                .catch(error => {
                    console.log(error);
                });
        },
        // campaign_id/company_id 는 호출부가 URL(cmp/cpn)에서 넘긴다 — store 의 평가 컨텍스트가 어긋나도 답변과 같은 대상에 저장
        async saveQuestionInProgress({dispatch, commit, state}, {question: new_question_in_progress, campaign_id, company_id}) {
            try {
                const formData = new FormData();
                formData.append('question_code', new_question_in_progress.question_code);
                formData.append('campaign_id', campaign_id);
                formData.append('company_id', company_id);
                formData.append('is_completed', new_question_in_progress.is_completed);
                formData.append('comment', new_question_in_progress.comment);
                
                await axios.post('/save_question_answer', formData);
                
                // console.log(response.data)
                // commit('update_question_in_progress', new_question_in_progress)
                // 화면 갱신
                let temp_template_in_progress = {...state.template_in_progress};
                th.breadthFirstSearch(temp_template_in_progress.template_contents, node => {
                    if (node.question_code == new_question_in_progress.question_code) {
                        node.is_completed = new_question_in_progress.is_completed;
                        node.comment = new_question_in_progress.comment;
                    }
                });
                
                commit('update_template_in_progress', temp_template_in_progress);
            } catch (error) {
                console.log(error);
                if (error.response) {
                    if (error.response.status === '401') {
                        await commonLogout();
                    }
                }
                throw error; // 호출부(Questions.vue)가 체크 원복·안내
            }
        },
        ///////////////////////// Public_Engagement /////////////////////////
        readPublicCampaign({commit, state}, campaign_id) {
            const path = state.backend_host + '/read_public_campaign';
            
            return axios.get(path, {
                params: {
                    campaign_id: campaign_id
                }
            })
                .then(response => {
                    if (response.data.is_public != true) {
                        window.alert('캠페인 접근 권한이 없습니다(참여제한 캠페인)');
                        history.go('http://dataflare.net');
                    }
                    commit('update_campaign_in_progress', response.data);
                    this.dispatch('readTemplateInProgress', response.data.template_code);
                })
                .catch(error => {
                    console.log(error);
                });
            
        },
        makePublicTemplateTree({commit, state}) {
            const path = state.backend_host + '/make_public_template_tree';
            
            return axios.get(path, {
                params: {
                    campaign_id: state.campaign_in_progress.campaign_id,
                }
            })
                .then(response => {
                    commit('make_template_tree', response.data);
                })
                .catch(error => {
                    console.log(error);
                });
        },
        /////////////////////////// Users ///////////////////////////////////
        async readTemplateTree({commit}, {template_code, company_id}) {
            try {
                // 트리 구조(/read_template)와 번역(/make_template_tree_by_template_code)을 병렬 조회한다.
                // read_template 은 번역 필드(question_name_e/_c 등)를 포함하지 않으므로,
                // 번역 배열을 question_code 로 매칭하여 각 노드에 병합한다.
                // 번역 조회가 실패해도 트리는 정상 표시되도록 해당 호출만 격리한다.
                const [_res_template, _res_i18n] = await Promise.all([
                    axios.get('/read_template', {
                        params: {template_code, company_id}
                    }),
                    axios.get(`/make_template_tree_by_template_code/${template_code}`).catch(() => ({ data: [] }))
                ]);

                const _template = _res_template.data;
                let _template_contents = typeof _template.template_contents === 'string'
                    ? JSON.parse(_template.template_contents)
                    : (_template.template_contents || []);

                const _i18n_array = Array.isArray(_res_i18n.data) ? _res_i18n.data : [];
                if (_i18n_array.length && Array.isArray(_template_contents) && _template_contents.length) {
                    const _i18n_map = _i18n_array.reduce((_map, _item) => {
                        _map[_item.question_code] = _item;
                        return _map;
                    }, {});
                    th.breadthFirstSearch(_template_contents, node => {
                        const _translation = _i18n_map[node.question_code];
                        if (_translation) {
                            node.question_name_e = _translation.question_name_e;
                            node.question_name_c = _translation.question_name_c;
                            node.question_infobox_e = _translation.question_infobox_e;
                            node.question_infobox_c = _translation.question_infobox_c;
                        }
                    });
                }

                const _template_tree = {
                    user_id: _template.user_id || null,
                    template_id: _template.id || null,
                    template_name: _template.template_name || null,
                    template_code: _template.template_code || null,
                    template_scoring: _template.template_scoring || null,
                    template_type: _template.template_type || null,
                    template_contents: _template_contents
                };

                commit('update_template_tree', _template_tree);
            } catch (error) {
                return Promise.reject(error);
            }
        },
        async saveTemplateTree({state, commit}, _updated_template_tree) {
            try {
                const formData = new FormData();
                if (_updated_template_tree) {
                    _updated_template_tree = {...state.template_tree, ..._updated_template_tree};
                } else {
                    _updated_template_tree = {...state.template_tree};
                }
                
                formData.append('user_id', state.user_id);
                formData.append('template_name', _updated_template_tree.template_name);
                formData.append('template_code', _updated_template_tree.template_code);
                formData.append('template_scoring', 'manual');
                formData.append('template_type', _updated_template_tree.template_type);
                formData.append('template_contents', JSON.stringify(_updated_template_tree.template_contents));
                
                const _updated_template = await axios.post('/save_template', formData);
                commit('update_template_tree', _updated_template.data);
                
                return _updated_template.data;
            } catch (error) {
                return Promise.reject(error);
            }
        },
        async saveQuestionComposition({commit, state}, _updated_question = null) {
            try {
                commit('align_question_contents');
                
                let {question_name, question_code, question_infobox, question_contents} = state.question_composition;
                // 백엔드는 _e/_c 가 없으면 기존 번역을 NULL 로 덮으므로 현재 값을 함께 보낸다(텍스트가 바뀌면 서버가 재번역)
                const _translations = _updated_question && _updated_question.question_code !== state.question_composition.question_code
                    ? {} : {
                        question_name_e: state.question_composition.question_name_e,
                        question_name_c: state.question_composition.question_name_c,
                        question_infobox_e: state.question_composition.question_infobox_e,
                        question_infobox_c: state.question_composition.question_infobox_c,
                    };
                if (_updated_question) {
                    question_name = _updated_question.question_name;
                    question_code = _updated_question.question_code;
                    question_infobox = _updated_question.question_infobox;
                    question_contents = _updated_question.question_contents;
                }
                
                const _res_saved_question = await axios.post('/admin/questions', {
                    question_name: question_name,
                    question_code: question_code,
                    question_infobox: question_infobox,
                    ..._translations,
                    question_contents: typeof question_contents === 'object' ? JSON.stringify(question_contents) : question_contents,
                    // question_contents: question_contents,
                    template_code: state.template_tree.template_code
                });
                
                commit('update_question_composition', _res_saved_question.data);
            } catch (error) {
                return Promise.reject(error);
            }
        },
        // 반환값: 마지막 요청이라 반영했으면 true, 더 새 요청이 있어 버렸으면 false (호출부는 false 면 이동하지 않는다)
        // _question_code 가 null 이면 조회하지 않고 진행 중인 요청만 무효화한다 (화면이 문항 컨텍스트를 비울 때)
        async readQuestionComposition({commit, dispatch}, _question_code) {
            const request_no = ++latest_question_composition;
            if (_question_code === null) return false;
            try {
                let new_question_composition = {
                    question_name: '',
                    question_name_e: '',
                    question_name_c: '',
                    question_code: '',
                    question_infobox: '',
                    question_infobox_e: '',
                    question_infobox_c: '',
                    question_contents: [],
                    template_code: ''
                };
                
                const response = await axios.get('/questions', {
                    params: {question_code: _question_code}
                });
                
                const {
                    question_name, question_name_e, question_name_c,
                    question_infobox, question_infobox_e, question_infobox_c,
                    question_code, question_contents, template_code
                } = response.data;
                
                new_question_composition = {
                    ...new_question_composition,
                    question_name, question_name_e, question_name_c,
                    question_infobox, question_infobox_e, question_infobox_c,
                    question_code, question_contents, template_code
                };

                if (request_no !== latest_question_composition) return false;
                commit('update_question_composition', new_question_composition);
                return true;
            } catch (error) {
                if (request_no !== latest_question_composition) return false; // 밀린 요청의 오류는 알리지 않는다
                return Promise.reject(error);
            }
        },
        async deleteQuestionComposition({}, question_code) {
            try {
                await axios.delete('/admin/questions', {params: {question_code}});
            } catch (error) {
                return Promise.reject(error);
            }
        },
        async readQuestionSubsInit({commit, state}) {
            try {
                let temp_result = [];
                let _question_contents = state.question_composition.question_contents;
                if (_question_contents && _question_contents.length) {
                    
                    const params = new URLSearchParams();
                    _question_contents.forEach(val => params.append('sub_codes', val));
                    const _res_subs = await axios.get('/subs/init', {params});
                    if (_res_subs.data.length) {
                        temp_result = state.question_composition.question_contents.reduce((_ordered_subs, _sub_code) => {
                            const _sub = _res_subs.data.find(({sub_code}) => sub_code === _sub_code);
                            if (_sub) _ordered_subs.push(generateSubcomponentDataBy(_sub));
                            return _ordered_subs;
                        }, []);
                    }
                }
                
                commit('update_question_subs', temp_result);
            } catch (error) {
                return Promise.reject(error);
            }
        },
        //   saveQuestionSubs({commit, state, dispatch}) {
        //       for(var i = 0; i < state.question_subs.length; i++) {
        //         dispatch('saveQuestionSub', state.question_subs[i])
        //       }
        //   },
        async saveQuestionSub({commit, state, dispatch}, new_sub) {
            try {
                if (!state.question_composition.question_code) {
                    throw new Error('선택된 질문이 없어 저장할 수 없습니다. 질문을 다시 선택해주세요.');
                }
                new_sub = generateSubcomponentDataBy({...new_sub});
                
                const _edited_subs = {
                    sub_code: new_sub.sub_code,
                    sub_type: new_sub.sub_type,
                    sub_condition: new_sub.sub_condition,
                    sub_data_header: new_sub.sub_data_header,
                    sub_data_contents: new_sub.sub_data_contents,
                    sub_priority: new_sub.sub_priority,
                    sub_child: new_sub.sub_child,
                    sub_parent: new_sub.sub_parent,
                    question_code: state.question_composition.question_code,
                    risk: new_sub.risk,
                    tags: new_sub.tags,
                    label: new_sub.label,
                };
                
                if (new_sub.sub_name) _edited_subs['sub_name'] = new_sub.sub_name;
                if (new_sub.sub_description) _edited_subs['sub_description'] = new_sub.sub_description;
                if (new_sub.sub_info) _edited_subs['sub_info'] = new_sub.sub_info;
                
                const emptyValidationSubField = [
                    'sub_name', 'sub_name_e', 'sub_name_c',
                    'sub_description', 'sub_description_e', 'sub_description_c',
                    'sub_info', 'sub_info_e', 'sub_info_c'
                ];
                
                emptyValidationSubField.forEach((_field) => {
                    if (new_sub[_field] && new_sub[_field] !== '' && new_sub[_field] !== ' ') {
                        _edited_subs[_field] = new_sub[_field];
                    }
                });
                
                const saved_sub_init = await axios.post('/subs/init', _edited_subs);
                if (!state.question_composition.question_contents.includes(saved_sub_init.data.sub_code)) {
                    const _question_composition = {...state.question_composition};
                    _question_composition.question_contents.push(saved_sub_init.data.sub_code);
                    
                    const _res_saved_question = await axios.post('/admin/questions', {
                        question_name: _question_composition.question_name,
                        question_code: _question_composition.question_code,
                        question_infobox: _question_composition.question_infobox,
                        // 백엔드는 _e/_c 가 없으면 기존 번역을 NULL 로 덮으므로 현재 값을 함께 보낸다
                        question_name_e: _question_composition.question_name_e,
                        question_name_c: _question_composition.question_name_c,
                        question_infobox_e: _question_composition.question_infobox_e,
                        question_infobox_c: _question_composition.question_infobox_c,
                        question_contents: _question_composition.question_contents,
                        template_code: state.template_tree.template_code
                    });
                    commit('update_question_composition', _res_saved_question.data);
                }
                
                await dispatch('readQuestionSubsInit');
            } catch (error) {
                return Promise.reject(error);
            }
        },
        async readSearchedSubs({commit}, search_keyword) {
            try {
                commit('reset_searched_subs');
                
                const response = await axios.get('/subs/init', {
                    params: {search_keyword}
                });
                
                const result = response.data;
                commit('update_searched_subs', result.searched_subs);
            } catch (error) {
                // 401 은 axios 인터셉터가 로그인 화면으로 보낸다
                if (!error.response) {
                    console.log(error);
                }
            }
        },
        async deleteSubfromDB({commit, state}, sub_code) {
            try {
                const path = state.backend_host + '/subs/init';
                const res_deleted = await axios.get(path, {params: {sub_code}});
                commit('delete_searched_sub', res_deleted.sub_code);
            } catch (error) {
                commit('delete_searched_sub', sub_code);
                commit('delete_question_sub', sub_code);
            }
        },
        async unlinkSub({commit, dispatch}, {sub_code}) {
            
            // 1) 화면에서 sub_code 링크 끊기
            commit('delete_searched_sub', sub_code);
            commit('delete_question_sub', sub_code);
            
            // 2) 저장하기
            await dispatch('saveQuestionComposition');
        },
        async savePortfolio({commit, state}, new_portfolio) {
            try {
                let portfolio_target_companies_id = [];
                
                for (let i = 0; i < new_portfolio.portfolio_target_companies.length; i++) {
                    portfolio_target_companies_id.push(new_portfolio.portfolio_target_companies[i].company_id);
                }
                
                const formData = new FormData();
                formData.append('e_mail', state.e_mail);
                formData.append('portfolio_id', new_portfolio.portfolio_id);
                formData.append('portfolio_name', new_portfolio.portfolio_name);
                formData.append('portfolio_description', new_portfolio.portfolio_description);
                formData.append('portfolio_target_companies_id', JSON.stringify(portfolio_target_companies_id));
                
                await axios.post('/save_portfolio', formData);
                commit('update_portfolio', new_portfolio);
            } catch (error) {
                // 401 은 axios 인터셉터가 로그인 화면으로 보낸다
                if (error.response) {
                    console.log(error.response);
                }
            }
        },
        async saveCampaign({commit, dispatch}, new_campaign) {
            try {
                let formData = new FormData;
                formData.append('user_id', new_campaign.user_id);
                formData.append('campaign_id', new_campaign.campaign_id);
                
                // campaign_name
                formData.append('campaign_name', new_campaign.campaign_name);
                if (new_campaign.campaign_name_e) formData.append('campaign_name_e', new_campaign.campaign_name_e);
                if (new_campaign.campaign_name_c) formData.append('campaign_name_c', new_campaign.campaign_name_c);
                
                // campaign_description
                formData.append('campaign_description', new_campaign.campaign_description == null ? '' : new_campaign.campaign_description);
                if (new_campaign.campaign_description_e) formData.append('campaign_description_e', new_campaign.campaign_description_e);
                if (new_campaign.campaign_description_c) formData.append('campaign_description_c', new_campaign.campaign_description_c);
                
                // policy_content
                formData.append('policy_content', new_campaign.policy_content == null ? '' : new_campaign.policy_content);
                if (new_campaign.policy_content_e) formData.append('policy_content_e', new_campaign.policy_content_e);
                if (new_campaign.policy_content_c) formData.append('policy_content_c', new_campaign.policy_content_c);
                
                formData.append('template_code', new_campaign.template_code);
                formData.append('period', new_campaign.period);
                formData.append('start_date', new_campaign.start_date);
                formData.append('end_date', new_campaign.end_date);
                formData.append('target_year', new_campaign.target_year);
                formData.append('campaign_type', new_campaign.campaign_type);
                formData.append('campaign_state', new_campaign.campaign_state);
                formData.append('campaign_target_companies_id', []),
                formData.append('process_options', JSON.stringify(new_campaign.process_options)),
                formData.append('is_public', false);
                formData.append('previous_campaign_id', new_campaign.previous_campaign_id);
                formData.append('auditors', JSON.stringify(new_campaign.auditors));
                
                if (typeof new_campaign.industry_code !== 'undefined') {
                    formData.append('industry_code', new_campaign.industry_code);
                }
                
                const response = await axios.post('/save_campaign', formData);
                commit('update_campaign', response.data);
                
            } catch (error) {
                // 호출부가 실패를 알 수 있게 그대로 던진다 (401 은 호출부 common_error_handling 이 처리)
                throw error;
            }
        },
        async login({commit, dispatch}, user) {
            try {
                const response = await axios.post('/login', {params: {user: user}});
                if (response.data['user_id']) {
                    let accessToken = response.data['accessToken'];
                    let user_name = response.data['user_name'];
                    let company_name = response.data['company_name'];
                    let company_id = response.data['company_id'];
                    let e_mail = response.data['e_mail'];
                    let is_admin = response.data['is_admin'];
                    let user_id = response.data['user_id'];
                    commit('auth_success', {
                        accessToken,
                        user_name,
                        company_name,
                        company_id,
                        e_mail,
                        is_admin,
                        user_id
                    });
                    return response;
                } else {
                    return response;
                }
            } catch (error) {
                console.log(error);
                await dispatch('logout');
                this.$router.push({name: 'Login'});
            }
        },
        async logout({commit, state}) {
            // 서버 세션 무효화가 실패해도(네트워크·5xx) 로컬 세션은 반드시 정리한다 — 공용 PC 에 로그인이 남지 않게.
            // 다시 throw 하지 않으므로 호출부(.then·await)는 그대로 로그인 화면으로 진행한다.
            try {
                await axios.post(state.backend_host + '/logout');
            } catch (error) {
                Sentry.captureException(error);
            } finally {
                Sentry.setUser(null);
                commit('logout');
                commit('reset_store');
                commit('ai_assessment/reset_my_ratings', null, {root: true});
            }
        },
        checkQeustionName({state}, params) {
            return axios.get('/admin/questions/category2/validate', params)
                .then((res) => {
                    return res;
                })
                .catch(err => {
                    console.log(' ~ ', err);
                    
                });
        }
    }
});

export default store;
